import DataBin from "./DataBin.js";

class DataBin2D extends DataBin
{
    /**
     * Create 2 dimensional data bin
     * @param {DataBin} binX - data bin for X axis
     * @param {DataBin} binY - data bin for Y axis
     */
    constructor(binX, binY) {
        if (!(binX instanceof DataBin)) {
            throw new TypeError('binX must be instance of DataBin');
        }

        if (!(binY instanceof DataBin)) {
            throw new TypeError('binY must be instance of DataBin');
        }

        super(binX.size, binX.offset);

        this.binX = binX;
        this.binY = binY;
    }

    /**
     * Allows to add new point to the bin
     * @param {Number} x - value on X axis
     * @param {Number} y - value on Y axis
     */
    add(x, y) {
        this.data.push([x, y]);
    }
    
    /**
     * Returns a copy of points assigned to this bin
     * @returns {Array} - two dimensional array, contains arrays of points, each point is represented as an array where first element represents value on X axis and second elements represents value on Y axis
     */
    getValues() {
        return this.data.concat([]);
    }

    /**
     * Returns smallest value allowed for this bin (inclusive) on X axis
     * @returns {Number}
     */
    fromWhereX() {
        return this.binX.offset;
    }

    /**
     * Returns biggest value allowed for this bin (exclusive) on X axis
     * @returns {Number}
     */
    toWhereX() {
        return this.binX.offset + this.binX.size;
    }

    /**
     * Returns smallest value allowed for this bin (inclusive) on Y axis
     * @returns {Number}
     */
    fromWhereY() {
        return this.binY.offset;
    }

    /**
     * Returns biggest value allowed for this bin (exclusive) on Y axis
     * @returns {Number}
     */
    toWhereY() {
        return this.binY.offset + this.binY.size;
    }

    centerX() {
        return this.binX.offset + this.binX.size / 2;
    }

    centerY() {
        return this.binY.offset + this.binY.size / 2;
    }
}

export default DataBin2D;